import { Component, HostBinding, Input } from "@angular/core";
import { asObject, TenantStatus } from "src/app/enum";

@Component({
  selector: "tenant-status-indicator",
  templateUrl: "./tenant-status-indicator.component.html",
  styleUrls: ['./tenant-status-indicator.component.scss']
})
export class TenantStatusIndicatorComponent {
    @Input() public value: TenantStatus;

    @HostBinding('class') public get hostClasses() {
        return `status--${asObject(TenantStatus, this.value).label}`;
    }
}